import Head from "next/head";
import { useRouter } from "next/router";
import { useTheme } from "@material-ui/core";

import { CANONICAL_HOST } from "lib/http";

export default function SeoApp() {
  const router = useRouter();
  const theme = useTheme();

  const canonical = CANONICAL_HOST + router.asPath;

  return (
    <Head>
      <title>Murfy</title>
      <link rel="canonical" key="canonical" href={canonical} />
      <meta property="og:site_name" key="og:site_name" content="Murfy Shop" />
      <meta name="theme-color" content={theme.palette.secondary.main} />
      <meta property="og:image" key="og:image" content={`${CANONICAL_HOST}/reconditionne/ogimage.png`} />
      <meta property="og:url" key="og:url" content={canonical} />
    </Head>
  );
}
